import React from 'react';
import './MarketingConsent.css';

export const MARKETING_CONSENT_TEXT =
  "Yes, sign me up for emails from Highlands Sports Bar & Grill about specials, events, and promotions. You can unsubscribe at any time.";

// Shared opt-in checkbox used by every form that collects an email address.
// `variant` is "dark" for the black page forms and "light" for the white footer.
const MarketingConsent = ({
  checked,
  onChange,
  id = 'marketingConsent',
  name = 'marketingConsent',
  variant = 'dark',
  disabled = false
}) => {
  return (
    <div className={`marketing-consent marketing-consent--${variant}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id}>{MARKETING_CONSENT_TEXT}</label>
    </div>
  );
};

export default MarketingConsent;
